import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-d8ade60c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "患者信息", -1); });
var _hoisted_4 = /*#__PURE__*/ _createTextVNode("男");
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("女");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_8 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_9 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_10 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_11 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_12 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_13 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_14 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "报告接收信息", -1); });
var _hoisted_15 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "样本信息", -1); });
var _hoisted_16 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_17 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_18 = /*#__PURE__*/ _createTextVNode("手术");
var _hoisted_19 = /*#__PURE__*/ _createTextVNode("穿刺");
var _hoisted_20 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, null, -1); });
var _hoisted_21 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_22 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_23 = { class: "submit-box" };
var _hoisted_24 = /*#__PURE__*/ _createTextVNode("确认提交");
var _hoisted_25 = { class: "overlay-wrapper" };
import { ref } from "vue";
import Esign from "@/components/esign.vue";
import { bindingInformationBySalesman, requestInfoByorderNo, validSampleBindingOrder, } from "@/api";
import { useRouter, useRoute } from "vue-router";
import { Toast, Dialog } from "vant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InformationBinding',
    setup: function (__props) {
        var _this = this;
        require("@/provide/wxConfig");
        var router = useRouter();
        var route = useRoute();
        var minDate = new Date(2012, 0, 1);
        var maxDate = new Date(new Date().getFullYear() + 2, 11, 31);
        var formRef = ref();
        var sampleCode = ref("");
        var patientName = ref("");
        var sex = ref(1);
        var age = ref();
        var clinicalDiagnosis = ref(""); // 临床诊断
        var diseaseStages = ref(); // 疾病分期
        var medicationHistory = ref(); // 用药史
        var medicalHistory = ref(); // 病史
        var allogeneicBloodTransfusion = ref(false); // 6个月内异体输血
        var organTransplantation = ref(false); // 器官移植
        var stemCellTransplantation = ref(false); // 干细胞移植
        var infectiousDiseases = ref(false); // 传染性疾病
        var preTreatmentPlan = ref(""); // 既往治疗方案
        var devTreatmentPlan = ref(""); // 拟定治疗方案
        var adress = ref(""); // 接收地址
        var emall = ref(""); // 接收邮箱
        var receiver = ref(""); // 接收人
        var tel = ref("");
        var samplingDate = ref([
            String(new Date().getFullYear()),
            new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1)
                : "" + (new Date().getMonth() + 1),
            new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : "" + new Date().getDate(),
        ]);
        var samplingDateLabel = ref();
        var samplingSite = ref(); // 采样部位
        var primaryStove = ref(false); // 是否为原发灶
        var sampleType = ref("surgery_puncture_fresh_tissue"); // 样本类型
        var sliceForm = ref("OPERATION"); //切片形式
        var sampleTypeLable = ref();
        var sampleNum = ref(1);
        var receivedOncogeneTesting = ref(false); // 既往接受过肿瘤基因检测
        var detectionDate = ref([
            String(new Date().getFullYear()),
            new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1)
                : "" + (new Date().getMonth() + 1),
            new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : "" + new Date().getDate(),
        ]); // 检测时间
        var detectionDateLabel = ref();
        var testResults = ref(); // 检测结果
        var esignImgUrl = ref("");
        var onLoadloading = ref(true);
        var loadingVisible = ref(true);
        var getInfoByOrderNo = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestInfoByorderNo(route.query.orderNo).catch(function () {
                            loadingVisible.value = false;
                            onLoadloading.value = false;
                            Toast("网络错误-05");
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            patientName.value = res.data.cardName;
                            sex.value = res.data.gender;
                            age.value = res.data.age;
                        }
                        loadingVisible.value = false;
                        onLoadloading.value = false;
                        return [2 /*return*/];
                }
            });
        }); };
        getInfoByOrderNo();
        var samplingDatePickerVisible = ref(false);
        var handleSamplingDateSelect = function (_a) {
            var selectedValues = _a.selectedValues;
            samplingDateLabel.value = selectedValues.join("/");
            samplingDate.value = selectedValues;
            samplingDatePickerVisible.value = false;
        };
        var onNumberPickerConfirm = function (_a) {
            var selectedOptions = _a.selectedOptions;
            sampleNum.value = selectedOptions[0].value;
            numberPickerVisible.value = false;
        };
        var detectionDatePickerVisible = ref(false);
        var handleDetectionDateSelect = function (_a) {
            var selectedValues = _a.selectedValues;
            detectionDateLabel.value = selectedValues.join("/");
            detectionDatePickerVisible.value = false;
            detectionDate.value = selectedValues;
        };
        var sampleTypePickerVisible = ref(false);
        var sampleTypeColumns = ref([
            { text: "新鲜组织", value: "surgery_puncture_fresh_tissue" },
            { text: "石蜡切片", value: "paraffin_section" },
            { text: "石蜡卷", value: "paraffin_roll" },
            { text: "石蜡块", value: "parffin_block" },
            { text: "其他样本", value: "other" },
        ]);
        var numberPickerVisible = ref(false);
        var onSampleTypeConfirm = function (_a) {
            var selectedOptions = _a.selectedOptions;
            console.log(selectedOptions);
            sampleTypePickerVisible.value = false;
            sampleType.value = selectedOptions[0].value;
            sampleTypeLable.value = selectedOptions[0].text;
        };
        var numberColumns = ref([]);
        for (var i = 1; i <= 30; i++) {
            numberColumns.value.push({
                text: i,
                value: i,
            });
        }
        var esignVisible = ref(false);
        var loading = ref(false);
        var handleValidSampleBindingOrder = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, validSampleBindingOrder(sampleCode.value, route.query.orderNo)];
            });
        }); };
        var handleBindingInformation = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, bindingInformationBySalesman({
                            patientName: patientName.value,
                            clinicalDiagnosis: clinicalDiagnosis.value,
                            diseaseStage: diseaseStages.value,
                            patientGender: sex.value,
                            organTransplant: organTransplantation.value,
                            patientAge: age.value,
                            allogeneicTransfusion: allogeneicBloodTransfusion.value,
                            infectiousDisease: infectiousDiseases.value,
                            formulateTreatmentPlan: devTreatmentPlan.value,
                            previousTreatmentRegimen: preTreatmentPlan.value,
                            reportReceiver: receiver.value,
                            medicationHistory: medicationHistory.value,
                            reportReceivingAddress: adress.value,
                            reportReceivingEmail: emall.value,
                            stemCellTransplant: stemCellTransplantation.value,
                            reportReceiverMobile: tel.value,
                            familyMedicalHistory: medicalHistory.value,
                            primaryTumor: primaryStove.value,
                            paraffinCount: [
                                "paraffin_section",
                                "paraffin_roll",
                                "parffin_block",
                            ].includes(sampleType.value)
                                ? sampleNum.value
                                : null,
                            samplingTime: samplingDate.value.join("-") + " 00:00:00",
                            sampleCode: sampleCode.value,
                            userSign: esignImgUrl.value,
                            samplingSite: samplingSite.value,
                            surgeryPunctureFreshTissueSite: sampleType.value === "surgery_puncture_fresh_tissue"
                                ? sampleNum.value
                                : null,
                            sampleType: sampleType.value,
                            sliceForm: sliceForm.value,
                            otherSamples: sampleType.value === "other" ? sampleNum.value : null,
                            testTime: receivedOncogeneTesting.value
                                ? detectionDate.value.join("-") + " 00:00:00"
                                : "",
                            hadTest: receivedOncogeneTesting.value,
                            testResult: receivedOncogeneTesting.value ? testResults.value : "",
                            orderNo: route.query.orderNo,
                            orderId: route.query.orderId,
                        })];
                    case 1:
                        res = _a.sent();
                        loading.value = false;
                        loadingVisible.value = false;
                        if (res.code === 200) {
                            router.replace("/salesman-binding-success?orderId=" + route.query.orderId);
                        }
                        else {
                            Toast(res.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var handleSubmit = function () {
            formRef.value.validate().then(function () { return __awaiter(_this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            loading.value = true;
                            loadingVisible.value = true;
                            return [4 /*yield*/, handleValidSampleBindingOrder()];
                        case 1:
                            res = _a.sent();
                            if (res.code === 200) {
                                handleBindingInformation();
                                return [2 /*return*/];
                            }
                            if (res.code === 201) {
                                loadingVisible.value = false;
                                Dialog.confirm({
                                    title: "是否继续上传信息",
                                    message: res.message,
                                    confirmButtonText: "继续申请",
                                    confirmButtonColor: "#3DABA4",
                                })
                                    .then(function () {
                                    loadingVisible.value = true;
                                    handleBindingInformation();
                                })
                                    .catch(function () {
                                    // on cancel
                                });
                            }
                            else {
                                loading.value = false;
                                loadingVisible.value = false;
                                Toast(res.message);
                            }
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        var handleScan = function () {
            wx.scanQRCode({
                needResult: 1,
                scanType: ["barCode"],
                success: function (res) {
                    var _a;
                    sampleCode.value = (_a = res.resultStr) === null || _a === void 0 ? void 0 : _a.split(",")[1];
                },
                complete: function (res) {
                    console.log(res);
                },
            });
        };
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_field = _resolveComponent("van-field");
            var _component_van_radio = _resolveComponent("van-radio");
            var _component_van_radio_group = _resolveComponent("van-radio-group");
            var _component_van_date_picker = _resolveComponent("van-date-picker");
            var _component_van_popup = _resolveComponent("van-popup");
            var _component_van_picker = _resolveComponent("van-picker");
            var _component_van_form = _resolveComponent("van-form");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "信息绑定",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_van_form, {
                        ref_key: "formRef",
                        ref: formRef
                    }, {
                        default: _withCtx(function () {
                            var _a, _b, _c, _d, _e, _f;
                            return [
                                _createVNode(_component_van_field, {
                                    modelValue: sampleCode.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((sampleCode).value = $event); }),
                                    label: "样本编码",
                                    placeholder: "请输入或扫描样本编码",
                                    rules: [{ required: true, message: '请输入或扫描样本编码' }]
                                }, {
                                    button: _withCtx(function () { return [
                                        _createVNode(_component_van_button, {
                                            size: "small",
                                            icon: "scan",
                                            onClick: handleScan
                                        })
                                    ]; }),
                                    _: 1
                                }, 8, ["modelValue"]),
                                _hoisted_3,
                                _createVNode(_component_van_field, {
                                    modelValue: patientName.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((patientName).value = $event); }),
                                    label: "患者姓名",
                                    placeholder: "请输入患者姓名",
                                    rules: [{ required: true, message: '请输入患者姓名' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, { label: "性别" }, {
                                    input: _withCtx(function () { return [
                                        _createVNode(_component_van_radio_group, {
                                            modelValue: sex.value,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((sex).value = $event); }),
                                            direction: "horizontal"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: 1
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_4
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: 0
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_5
                                                    ]; }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_van_field, {
                                    modelValue: age.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((age).value = $event); }),
                                    label: "年龄",
                                    placeholder: "请输入患者年龄",
                                    rules: [{ required: true, message: '请输入患者年龄' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                    modelValue: clinicalDiagnosis.value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((clinicalDiagnosis).value = $event); }),
                                    label: "临床诊断",
                                    maxlength: "25",
                                    placeholder: "请输入临床诊断（最多25字）",
                                    rules: [{ required: true, message: '请输入临床诊断（最多25字）' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                    modelValue: diseaseStages.value,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((diseaseStages).value = $event); }),
                                    label: "疾病分期",
                                    maxlength: "5",
                                    placeholder: "请输入疾病分期（最多5字）",
                                    rules: [{ required: true, message: '请输入疾病分期（最多5字）' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                    modelValue: medicationHistory.value,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((medicationHistory).value = $event); }),
                                    label: "用药史",
                                    maxlength: "20",
                                    placeholder: "请输入用药史（最多20字）",
                                    rules: [{ required: true, message: '请输入用药史（最多20字）' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                    modelValue: medicalHistory.value,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((medicalHistory).value = $event); }),
                                    label: "病史",
                                    placeholder: "请输入既往/家族史（最多10字）",
                                    maxlength: "10",
                                    rules: [
                                        { required: true, message: '请输入请输入既往/家族史（最多10字）' },
                                    ]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                    label: "6个月内异体输血",
                                    "label-width": "8em"
                                }, {
                                    input: _withCtx(function () { return [
                                        _createVNode(_component_van_radio_group, {
                                            modelValue: allogeneicBloodTransfusion.value,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((allogeneicBloodTransfusion).value = $event); }),
                                            direction: "horizontal"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: true
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_6
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: false
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_7
                                                    ]; }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_van_field, {
                                    label: "器官移植",
                                    "label-width": "8em"
                                }, {
                                    input: _withCtx(function () { return [
                                        _createVNode(_component_van_radio_group, {
                                            modelValue: organTransplantation.value,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((organTransplantation).value = $event); }),
                                            direction: "horizontal"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: true
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_8
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: false
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_9
                                                    ]; }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_van_field, {
                                    label: "干细胞移植",
                                    "label-width": "8em"
                                }, {
                                    input: _withCtx(function () { return [
                                        _createVNode(_component_van_radio_group, {
                                            modelValue: stemCellTransplantation.value,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return ((stemCellTransplantation).value = $event); }),
                                            direction: "horizontal"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: true
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_10
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: false
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_11
                                                    ]; }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_van_field, {
                                    label: "传染性疾病",
                                    "label-width": "8em"
                                }, {
                                    input: _withCtx(function () { return [
                                        _createVNode(_component_van_radio_group, {
                                            modelValue: infectiousDiseases.value,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((infectiousDiseases).value = $event); }),
                                            direction: "horizontal"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: true
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_12
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: false
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_13
                                                    ]; }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_van_field, {
                                    modelValue: preTreatmentPlan.value,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((preTreatmentPlan).value = $event); }),
                                    rows: "2",
                                    autosize: "",
                                    label: "既往治疗方案",
                                    type: "textarea",
                                    maxlength: "30",
                                    placeholder: "请输入即往治疗方案（最多30字）",
                                    "show-word-limit": "",
                                    rules: [
                                        { required: true, message: '请输入即往治疗方案（最多30字）' },
                                    ]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                    modelValue: devTreatmentPlan.value,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) { return ((devTreatmentPlan).value = $event); }),
                                    rows: "2",
                                    autosize: "",
                                    label: "拟定治疗方案",
                                    type: "textarea",
                                    maxlength: "30",
                                    placeholder: "请输入拟定治疗方案（最多30字）",
                                    "show-word-limit": "",
                                    rules: [
                                        { required: true, message: '请输入拟定治疗方案（最多30字）' },
                                    ]
                                }, null, 8, ["modelValue"]),
                                _hoisted_14,
                                _createVNode(_component_van_field, {
                                    modelValue: adress.value,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) { return ((adress).value = $event); }),
                                    label: "接收地址",
                                    placeholder: "请输入接收地址"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                    modelValue: emall.value,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) { return ((emall).value = $event); }),
                                    label: "接收邮箱",
                                    placeholder: "请输入接收邮箱"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                    modelValue: receiver.value,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) { return ((receiver).value = $event); }),
                                    label: "接收人",
                                    placeholder: "请输入接收人姓名",
                                    rules: [{ required: true, message: '请输入接收人姓名' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                    modelValue: tel.value,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) { return ((tel).value = $event); }),
                                    label: "联系电话",
                                    placeholder: "请输入联系电话",
                                    rules: [{ required: true, message: '请输入联系电话' }]
                                }, null, 8, ["modelValue"]),
                                _hoisted_15,
                                _createVNode(_component_van_field, {
                                    modelValue: samplingDateLabel.value,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) { return ((samplingDateLabel).value = $event); }),
                                    "is-link": "",
                                    readonly: "",
                                    label: "采样时间",
                                    placeholder: "请选择证样本时间",
                                    onClick: _cache[20] || (_cache[20] = function ($event) { return (samplingDatePickerVisible.value = true); }),
                                    rules: [{ required: true, message: '请选择证样本时间' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_popup, {
                                    show: samplingDatePickerVisible.value,
                                    "onUpdate:show": _cache[23] || (_cache[23] = function ($event) { return ((samplingDatePickerVisible).value = $event); }),
                                    position: "bottom"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_van_date_picker, {
                                            modelValue: samplingDate.value,
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) { return ((samplingDate).value = $event); }),
                                            title: "选择日期",
                                            "min-date": _unref(minDate),
                                            "max-date": _unref(maxDate),
                                            onConfirm: handleSamplingDateSelect,
                                            onCancel: _cache[22] || (_cache[22] = function ($event) { return (samplingDatePickerVisible.value = false); })
                                        }, null, 8, ["modelValue", "min-date", "max-date"])
                                    ]; }),
                                    _: 1
                                }, 8, ["show"]),
                                _createVNode(_component_van_field, {
                                    modelValue: samplingSite.value,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = function ($event) { return ((samplingSite).value = $event); }),
                                    label: "采样部位",
                                    placeholder: "请填写采样部位（最多6字）",
                                    maxlength: "6",
                                    rules: [{ required: true, message: '请填写采样部位（最多6字）' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, { label: "是否为原发灶" }, {
                                    input: _withCtx(function () { return [
                                        _createVNode(_component_van_radio_group, {
                                            modelValue: primaryStove.value,
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = function ($event) { return ((primaryStove).value = $event); }),
                                            direction: "horizontal"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: true
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_16
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: false
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_17
                                                    ]; }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_van_field, {
                                    modelValue: sampleTypeLable.value,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = function ($event) { return ((sampleTypeLable).value = $event); }),
                                    "is-link": "",
                                    readonly: "",
                                    label: "样本类型",
                                    placeholder: "请选择样本类型",
                                    onClick: _cache[27] || (_cache[27] = function ($event) { return (sampleTypePickerVisible.value = true); })
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_popup, {
                                    show: sampleTypePickerVisible.value,
                                    "onUpdate:show": _cache[29] || (_cache[29] = function ($event) { return ((sampleTypePickerVisible).value = $event); }),
                                    position: "bottom"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_van_picker, {
                                            columns: sampleTypeColumns.value,
                                            onConfirm: onSampleTypeConfirm,
                                            onCancel: _cache[28] || (_cache[28] = function ($event) { return (sampleTypePickerVisible.value = false); })
                                        }, null, 8, ["columns"])
                                    ]; }),
                                    _: 1
                                }, 8, ["show"]),
                                _createVNode(_component_van_field, { label: "切片形式" }, {
                                    input: _withCtx(function () { return [
                                        _createVNode(_component_van_radio_group, {
                                            modelValue: sliceForm.value,
                                            "onUpdate:modelValue": _cache[30] || (_cache[30] = function ($event) { return ((sliceForm).value = $event); }),
                                            direction: "horizontal"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: "OPERATION"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_18
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: "PUNCTURE"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_19
                                                    ]; }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (['surgery_puncture_fresh_tissue', 'other'].includes(sampleType.value))
                                    ? (_openBlock(), _createBlock(_component_van_field, {
                                        key: 0,
                                        modelValue: sampleNum.value,
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = function ($event) { return ((sampleNum).value = $event); }),
                                        label: (_a = sampleTypeColumns.value.find(function (item) { return item.value === sampleType.value; })) === null || _a === void 0 ? void 0 : _a.text,
                                        placeholder: "\u8BF7\u8F93\u5165" + ((_b = sampleTypeColumns.value.find(function (item) { return item.value === sampleType.value; })) === null || _b === void 0 ? void 0 : _b.text),
                                        rules: [
                                            {
                                                required: true,
                                                message: "\u8BF7\u8F93\u5165" + ((_c = sampleTypeColumns.value.find(function (item) { return item.value === sampleType.value; })) === null || _c === void 0 ? void 0 : _c.text),
                                            },
                                        ]
                                    }, null, 8, ["modelValue", "label", "placeholder", "rules"]))
                                    : _createCommentVNode("", true),
                                (['paraffin_section', 'paraffin_roll', 'parffin_block'].includes(sampleType.value))
                                    ? (_openBlock(), _createBlock(_component_van_field, {
                                        key: 1,
                                        modelValue: sampleNum.value,
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = function ($event) { return ((sampleNum).value = $event); }),
                                        "is-link": "",
                                        readonly: "",
                                        label: (_d = sampleTypeColumns.value.find(function (item) { return item.value === sampleType.value; })) === null || _d === void 0 ? void 0 : _d.text,
                                        placeholder: "\u8BF7\u9009\u62E9" + ((_e = sampleTypeColumns.value.find(function (item) { return item.value === sampleType.value; })) === null || _e === void 0 ? void 0 : _e.text),
                                        onClick: _cache[33] || (_cache[33] = function ($event) { return (numberPickerVisible.value = true); }),
                                        rules: [
                                            {
                                                required: true,
                                                message: "\u8BF7\u9009\u62E9" + ((_f = sampleTypeColumns.value.find(function (item) { return item.value === sampleType.value; })) === null || _f === void 0 ? void 0 : _f.text),
                                            },
                                        ]
                                    }, null, 8, ["modelValue", "label", "placeholder", "rules"]))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_van_popup, {
                                    show: numberPickerVisible.value,
                                    "onUpdate:show": _cache[35] || (_cache[35] = function ($event) { return ((numberPickerVisible).value = $event); }),
                                    position: "bottom"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_van_picker, {
                                            columns: numberColumns.value,
                                            onConfirm: onNumberPickerConfirm,
                                            onCancel: _cache[34] || (_cache[34] = function ($event) { return (numberPickerVisible.value = false); })
                                        }, null, 8, ["columns"])
                                    ]; }),
                                    _: 1
                                }, 8, ["show"]),
                                _hoisted_20,
                                _createVNode(_component_van_field, {
                                    label: "既往接受过肿瘤基因检测",
                                    "label-width": "11em"
                                }, {
                                    input: _withCtx(function () { return [
                                        _createVNode(_component_van_radio_group, {
                                            modelValue: receivedOncogeneTesting.value,
                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = function ($event) { return ((receivedOncogeneTesting).value = $event); }),
                                            direction: "horizontal"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: true
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_21
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_radio, {
                                                    "checked-color": "#3DABA4",
                                                    name: false
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_22
                                                    ]; }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (receivedOncogeneTesting.value)
                                    ? (_openBlock(), _createBlock(_component_van_field, {
                                        key: 2,
                                        modelValue: detectionDateLabel.value,
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = function ($event) { return ((detectionDateLabel).value = $event); }),
                                        "is-link": "",
                                        readonly: "",
                                        label: "检测时间",
                                        placeholder: "请选择检测时间",
                                        onClick: _cache[38] || (_cache[38] = function ($event) { return (detectionDatePickerVisible.value = true); }),
                                        rules: [{ required: true, message: '请选择检测时间' }]
                                    }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_van_popup, {
                                    show: detectionDatePickerVisible.value,
                                    "onUpdate:show": _cache[41] || (_cache[41] = function ($event) { return ((detectionDatePickerVisible).value = $event); }),
                                    position: "bottom"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_van_date_picker, {
                                            modelValue: detectionDate.value,
                                            "onUpdate:modelValue": _cache[39] || (_cache[39] = function ($event) { return ((detectionDate).value = $event); }),
                                            title: "选择日期",
                                            "min-date": _unref(minDate),
                                            "max-date": _unref(maxDate),
                                            onConfirm: handleDetectionDateSelect,
                                            onCancel: _cache[40] || (_cache[40] = function ($event) { return (detectionDatePickerVisible.value = false); })
                                        }, null, 8, ["modelValue", "min-date", "max-date"])
                                    ]; }),
                                    _: 1
                                }, 8, ["show"]),
                                (receivedOncogeneTesting.value)
                                    ? (_openBlock(), _createBlock(_component_van_field, {
                                        key: 3,
                                        modelValue: testResults.value,
                                        "onUpdate:modelValue": _cache[42] || (_cache[42] = function ($event) { return ((testResults).value = $event); }),
                                        label: "检测结果",
                                        maxlength: "7",
                                        placeholder: "请输入检测结果（最多7字）",
                                        rules: [{ required: true, message: '请输入检测结果（最多7字）' }]
                                    }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_component_van_button, {
                                        color: "#3DABA4",
                                        size: "large",
                                        round: "",
                                        onClick: handleSubmit,
                                        loading: loading.value
                                    }, {
                                        default: _withCtx(function () { return [
                                            _hoisted_24
                                        ]; }),
                                        _: 1
                                    }, 8, ["loading"])
                                ])
                            ];
                        }),
                        _: 1
                    }, 512)
                ], 512), [
                    [_vShow, !onLoadloading.value]
                ]),
                (esignVisible.value)
                    ? (_openBlock(), _createBlock(Esign, {
                        key: 0,
                        onCancel: _cache[43] || (_cache[43] = function ($event) { return (esignVisible.value = false); }),
                        onOk: _cache[44] || (_cache[44] =
                            function (imgUrl) {
                                esignImgUrl.value = imgUrl;
                                esignVisible.value = false;
                            })
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_component_van_overlay, {
                    show: loadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
